<template>
  <div>
    <!-- 媒体预览弹窗 -->
    <van-popup v-if="isPreviewVisible" v-model="isPreviewVisible" class="preview-popup" closeable position="center">
      <van-swipe v-model="currentIndex" autoplay="0" ref="swipe" show-indicators class="full-screen-swipe">
        <!-- 遍历媒体列表 -->
        <van-swipe-item v-for="(item, index) in mediaList" :key="index">
          <!-- 图片预览 -->
          <img v-if="!isVideo(item)" :src="item" class="full-screen-media" alt="图片" />
          <!-- 视频预览 -->
          <div v-else class="video-container">
            <video ref="videos" :src="item" class="full-screen-media" muted loop playsinline autoplay></video>
          </div>
        </van-swipe-item>
      </van-swipe>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Swipe, SwipeItem } from 'vant'

export default {
  name: 'MediaPreview',
  components: {
    'van-popup': Popup,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
  },
  props: {
    mediaList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      isPreviewVisible: false, // 控制预览弹窗显示
      currentIndex: 0, // 当前媒体索引
      videoRefs: [], // 视频元素引用
    }
  },
  methods: {
    isVideo(url) {
      // 判断是否为视频
      return /\.(mp4|avi|mov|mkv|webm|flv)$/i.test(url)
    },
    openPreview(index) {
      this.currentIndex = index
      this.isPreviewVisible = true

      this.$nextTick(() => {
        if (this.$refs.swipe) {
          this.$refs.swipe.swipeTo(index)
        } else {
          console.error('Swipe component not found')
        }
      })
    },
    // handleVideoPlay(index) {
    //   this.pauseAllVideosExcept(index)
    // },
    // pauseAllVideosExcept(index) {
    //   // 暂停除当前播放的视频外的所有视频
    //   this.videoRefs.forEach((video, idx) => {
    //     if (index !== idx && video && !video.paused) {
    //       video.pause()
    //     }
    //   })
    // },
  },
  mounted() {
    // 在挂载后获取所有视频元素的引用
    this.$nextTick(() => {
      this.videoRefs = this.$refs.videos
    })
  },
}
</script>

<style scoped>
.preview-popup {
  width: 100vw;
  height: 100vh;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-screen-swipe {
  width: 100vw;
  height: 100vh;
}

.full-screen-media {
  width: 100vw;
  height: 100vh;
  object-fit: contain; /* 保持内容等比例缩放 */
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
